// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"18b6fd17","455":"34b911ba","611":"7cb076ab","707":"7d2051c9","843":"7ae25bb2","888":"c866f27e","977":"e0f6af88"}[chunkId] + ".chunk.js";
};